import React from 'react';

function EPCertificates() {
  return (
    <div>EPCertificates</div>
  );
}

export default EPCertificates;
